export const pageStyle = {
  height: '1850vh',
  pyramid: '500vh',
  married: '700vh',
  price: '950vh',
  aging: '1200vh',
  carto: '1400vh',
  empty: '1650vh',
};
